// Generated by CoffeeScript 2.7.0
var Clipboard;

export default Clipboard = class Clipboard {
  static copy(input, options = {}) {
    var successful;
    options = _.extend({
      clearSelection: false
    }, options);
    input = DomMaster.wrap(input).node;
    input.select();
    successful = typeof document.execCommand === "function" ? document.execCommand('copy') : void 0;
    input.blur();
    if (options.clearSelection) {
      if (document.selection) {
        document.selection.empty();
      } else if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
    }
    return !!successful;
  }

};
